module.exports = __webpack_public_path__ + "fonts/TTMarxiana-Antiqua.e1d958d2.woff2";